/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from 'styled-components';
export var breakpoints = {
  small: 480,
  medium: 1200,
  large: 1800,
  v2Mobile: 480,
  v2Tablet: 1080,
  v2Desktop: 1280,
  v2XLargeDesktop: 1680,

  /**
   * New Design System Breakpoints
   */
  xs: null,
  sm: null,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
export var multipliers = {
  small: function small(value) {
    return "".concat(value / 3.65, "vw");
  },
  medium: function medium(value) {
    return "".concat(value / 12, "vw");
  },
  mediumUp: function mediumUp(value) {
    return "".concat(value, "px");
  },
  mediumDown: function mediumDown(value) {
    return "".concat(value / 12, "vw");
  },
  large: function large(value) {
    return "".concat(value * 1.25, "px");
  },
  v2Mobile: function v2Mobile(value) {
    return "".concat(value / 4.8, "vw");
  },
  v2Tablet: function v2Tablet(value) {
    return "".concat(value / 10.8, "vw");
  },
  v2Desktop: function v2Desktop(value) {
    return "".concat(value, "px");
  },
  v2LargeDesktop: function v2LargeDesktop(value) {
    return "".concat(value, "px");
  },
  v2XLargeDesktop: function v2XLargeDesktop(value) {
    return "".concat(value, "px");
  },
  xs: function xs(value) {
    return "".concat(value / 4.8, "vw");
  },
  sm: function sm(value) {
    return "".concat(value / 4.8, "vw");
  },
  md: function md(value) {
    return "".concat(value / 10.8, "vw");
  },
  lg: function lg(value) {
    return "".concat(value, "px");
  },
  xl: function xl(value) {
    return "".concat(value, "px");
  },
  xxl: function xxl(value) {
    return "".concat(value, "px");
  }
};
export var mediaQueries = {
  small: '(max-width: 479px)',
  mediumDown: '(min-width: 480px) and (max-width: 1199px)',
  mediumUp: '(min-width: 1200px) and (max-width: 1799px)',
  medium: '(min-width: 480px) and (max-width: 1799px)',
  large: '(min-width: 1800px)',
  // new breakpoints introduced in Header and Footer
  v2Mobile: '(max-width: 480px)',
  v2Tablet: '(min-width: 481px) and (max-width: 1080px)',
  v2Desktop: '(min-width: 1081px) and (max-width: 1279px)',
  v2LargeDesktop: '(min-width: 1280px) and (max-width: 1679px)',
  v2XLargeDesktop: '(min-width: 1680px)',

  /**
   * New Design System Breakpoints
   */
  xs: '(min-width: 0px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1400px)'
};

var getBreakpointCss = function getBreakpointCss(media, style) {
  return css(["@media ", "{", "}"], media, style);
};

export var mq = Object.keys(mediaQueries).reduce(function (acc, q) {
  acc[q] = function (style) {
    return getBreakpointCss(mediaQueries[q], style);
  };

  return acc;
}, {});
export var viewportsArray = ['small', 'mediumDown', 'mediumUp', 'large'];